// extracted by css-extract-rspack-plugin
export default {"alert-list-results":"src-features-Weather-features-WeatherAlerts-features-AlertList-AlertList-module__alert-list-results-P2MkOs","alertListResults":"src-features-Weather-features-WeatherAlerts-features-AlertList-AlertList-module__alert-list-results-P2MkOs"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"alert-list-results\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-AlertList-module__alert-list-results-P2MkOs\",\"alertListResults\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-AlertList-module__alert-list-results-P2MkOs\"}";
        // 1791855167296
        var cssReload = require("../../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  